module.exports = __webpack_public_path__ + "img/background.e8ba6c6b.png";